import { render, staticRenderFns } from "./ShieldCarousel.vue?vue&type=template&id=efce4360&scoped=true&"
import script from "./ShieldCarousel.vue?vue&type=script&lang=js&"
export * from "./ShieldCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ShieldCarousel.vue?vue&type=style&index=0&id=efce4360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efce4360",
  null
  
)

export default component.exports